export enum DISPATCH_TYPE {
  SHIPOUT = 1,
  RETURN_SHIPOUT = 2,
  RINGSIZE = 3,
}
